import { Link } from "wouter";

interface ArticleCardProps {
  article: any;
}

const ARTICLE_IMAGES = [
  "/store-seating.jpg",
  "/store-entrance.jpg",
  "/store-aisle.jpg",
];

export default function ArticleCard({ article }: ArticleCardProps) {
  const publishedDate = article.publishedAt
    ? new Date(article.publishedAt).toLocaleDateString("ja-JP", {
        year: "numeric",
        month: "short",
        day: "numeric",
      })
    : null;

  const thumbnailUrl = article.thumbnailUrl || ARTICLE_IMAGES[article.id % ARTICLE_IMAGES.length];

  return (
    <Link href={`/articles/${article.slug}`}>
      <div className="card-hover group cursor-pointer h-full">
        {/* Thumbnail */}
        <div className="aspect-[16/9] overflow-hidden bg-stone-200 relative">
          <img
            src={thumbnailUrl}
            alt={article.title}
            className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
          />
          {/* Category badge */}
          {article.category && (
            <div className="absolute top-3 left-3">
              <span className="bg-white/90 backdrop-blur-sm text-stone-900 rounded-full px-3 py-1 text-xs font-medium">
                {article.category}
              </span>
            </div>
          )}
        </div>

        {/* Content */}
        <div className="p-5">
          <div className="mb-2 flex items-center gap-2 text-xs text-stone-500">
            {publishedDate && (
              <time>{publishedDate}</time>
            )}
          </div>

          <h3 className="font-semibold text-lg text-stone-900 group-hover:text-teal-600 transition-colors line-clamp-2">
            {article.title}
          </h3>

          {article.excerpt && (
            <p className="mt-2 text-sm text-stone-500 line-clamp-2">
              {article.excerpt}
            </p>
          )}
        </div>
      </div>
    </Link>
  );
}
